import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8212d8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout-main" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-footer-arrow" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "footer-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_redpack_left_bottom = _resolveComponent("redpack-left-bottom")!

  return (!_ctx.slotOther)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(`skin-slot-${_ctx.skin}`), {
        key: 0,
        class: "layout",
        style: _normalizeStyle({
      minHeight: _ctx.screenHeight + 'px',
    }),
        onTouchstart: _ctx.touchStartHandler,
        onTouchmove: _ctx.touchmoveHandler,
        onTouchend: _ctx.touchEndHandler
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "main-container",
              style: _normalizeStyle(_ctx.phoneStyle)
            }, [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "header", {}, undefined, true)
              ])
            ], 4)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([
        'footer',
        _ctx.footerAnimation.show ? 'show' : 'hide',
      ]),
            onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.animationend && _ctx.animationend(...args)))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['footer-arrow-container', !_ctx.footerAnimation.show && 'hide'])
            }, _hoisted_4, 2),
            _createElementVNode("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
            ])
          ], 34),
          (_ctx.skin === 'c')
            ? (_openBlock(), _createBlock(_component_redpack_left_bottom, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }, 40, ["style", "onTouchstart", "onTouchmove", "onTouchend"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "mask-container",
        style: _normalizeStyle({
      minHeight: _ctx.screenHeight + 'px',
    })
      }, [
        _renderSlot(_ctx.$slots, "other", {}, undefined, true)
      ], 4))
}